<template>
    <div class="top-banner-bg" :style="cssStyles" :class="cssClass">
        <video v-if="video" playsinline autoplay muted loop :poster="imageSource">
            <source :src="video" type="video/mp4">
        </video>
        <div v-if="shade" :class="shadeCssClass">&nbsp;</div>
        <div v-if="bottomContent" :class="menuShadeCssClass">&nbsp;</div>
        <divider v-else-if="!centerContent" :height="75"/>
        <div class="py-3 py-md-4 py-lg-5 content-container" :class="bottomContent ? 'mb-0' : null">
            <slot />
        </div>
        <slot name="endContent"/>
    </div>
</template>
<script type="text/javascript">
    import ApiConfig from '@/config/api.json';
    import CommonComponents from '@/components/Common.vue';

    import { UseUIStore } from '@/store/UI.js';
    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        props: {
            image: {
                type: String,
            },

            thin: {
                type: Boolean,
                default: false,
            },

            // override the thin value
            // for all sizes
            vHeight: {
                type: String,
            },

            bgTop: {
                type: Boolean,
                default: true,
            },

            video: {
                type: String,
            },

            // between 2-8
            shade: {
                type: Number,
                default: 3,
            },

            // if the content should appear on the bottom
            bottomContent: {
                type: Boolean,
                default: false,
            },

            // if the content should appear in the middel
            centerContent: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            imageSource() {
                if (this.image) {
                    return this.image.replace('[PCDN]', ApiConfig.propertyImagesCDN).replace('[CDN]', ApiConfig.imagesCDN);
                }
                return null;
            },

            cssStyles() {
                if ((!this.video) && (this.imageSource)) {
                    return `background-image:url(${this.imageSource});`
                }
                return null;
            },

            cssClass() {
                let cls = [];
                if (this.vHeight) {
                    cls.push(this.vHeight);
                }
                else {
                    if (this.uiStore.isTablet) {
                        if (this.thin) {
                            cls.push('vh-50');
                        }
                        else {
                            cls.push('vh-60');
                        }
                    }
                    else {
                        if (this.thin) {
                            cls.push('vh-70');
                        }
                        else {
                            cls.push('vh-100');
                        }
                    }
                }

                if (this.bgTop) {
                    cls.push('bg-top');
                }

                if (this.video) {
                    cls.push('video-bg-container');
                }

                if (this.bottomContent) {
                    cls.push('d-flex');
                    cls.push('flex-column');
                    cls.push('align-items-end');
                }
                else if (this.centerContent) {
                    cls.push('d-flex');
                    cls.push('flex-column');
                    cls.push('align-items-center');
                    cls.push('justify-content-center');
                }

                return cls;
            },

            shadeCssClass() {
                if (this.shade) {
                    if (this.bottomContent) {
                        return 'shade shade-bottom-'+this.shade;
                    }
                    else {
                        return 'shade shade-'+this.shade;
                    }
                }
                return null;
            },

            menuShadeCssClass() {
                return 'vh-20 shade shade-'+this.shade;
            }
        },
    };

</script>